import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'

export function getCurriculumCountryCodeWithGradePrefix(countryCode: string): string {
  return `grade-${countryCode && countryCode.trim().length > 0 ? countryCode : CurriculumCountryCodes.DEFAULT}`
}
